import { defineNuxtPlugin } from '#app';

/**
 * Secure Strapi plugin
 * 
 * SECURITY UPDATE: April 2025
 * All direct references to backend URLs have been replaced with secure server proxies
 * to prevent exposing sensitive backend URLs in client-side code.
 */
export default defineNuxtPlugin((nuxtApp) => {

  /**
   * Makes a secure request to the Strapi API via server proxy
   * This prevents exposing sensitive backend URLs in client-side code
   */
  const makeRequest = async (endpoint: string, options: any = {}) => {
    try {
      // Use secure server proxy instead of direct Strapi URL
      const url = `/api/strapi/proxy?collection=${endpoint}`;
      console.log('🟢 Making secure Strapi request via proxy');
      
      const response = await $fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      });

      console.log('✅ Strapi response received');
      return response;
    } catch (error) {
      console.error('🔴 Strapi error:', error);
      throw error;
    }
  };

  return {
    provide: {
      strapi: {
        findOne: async (collection: string, params: any = {}) => {
          const queryString = new URLSearchParams(params).toString();
          return makeRequest(`${collection}?${queryString}`);
        },
        find: async (collection: string, params: any = {}) => {
          const queryString = new URLSearchParams(params).toString();
          return makeRequest(`${collection}?${queryString}`);
        },
      },
    },
  };
});
